import { HeadingTypeTemplate as IHeadingTypeTemplate } from "@/states/page-editor/template-parts/heading";
import { contentToHtml } from "@/utils/draft";

interface Props {
  part: IHeadingTypeTemplate;
}

export default function HeadingContent({ part }: Props) {
  if (!part.title || !part.title.content) {
    return <></>;
  }

  return (
    <div className="px-2 md:px-0" style={part.bgCssProperties}>
      <div
        dangerouslySetInnerHTML={{
          __html: contentToHtml(part.title.content),
        }}
        className="flex flex-col max-w-full min-h-[1.5em] text-2xl font-bold leading-normal text-center break-all md:text-[32px]"
        style={part.title.textBaseStyle}
      ></div>
    </div>
  );
}
